import { apiPlugin, storyblokInit } from '@storyblok/react/rsc';
import { components } from 'pages/StoryBlok';
import { STORY_BLOK_ACCESS_TOKEN } from 'src/envVariables';

export const storyBlokInit = () =>
  storyblokInit({
    accessToken: STORY_BLOK_ACCESS_TOKEN,
    use: [apiPlugin],
    components,
    apiOptions: {
      region: '',
    },
  });
